import { PRIMARY_COLOR } from "config/constants";
import PulseLoader from "react-spinners/PulseLoader";

const LoadingIndicator = ({ color = PRIMARY_COLOR, size = 10 }) => {
  return (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
      <PulseLoader
        color={color}
        loading={true}
        // cssOverride={override}
        size={size}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )
}

export default LoadingIndicator;